// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u2-2";
export var chatLink = "_u2-0";
export var chatText = "_u2-1";